module.exports = __webpack_public_path__ + "img/Vector.482e16cc.svg";